interface State {
    language: string,
}

const state: State = {
    language: 'EN',
}

export { State, state }